import React, { FunctionComponent } from 'react';
import { Container, Icon } from './styles';
import IcWarning from '../../assets/icons/ic_warning.svg';

interface Props {
  title: string;
  'data-cy'?: string;
}

const CardInfo: FunctionComponent<Props> = ({ children, title, 'data-cy': dataCy }) => (
  <Container data-cy={dataCy} >
    <Icon src={IcWarning} />
    <h1>{title}</h1>
    {children}
  </Container>
);

export default CardInfo;
